module.exports = __webpack_public_path__ + "static/media/logo-sign.b2e61498.png";